if (!customElements.get('bitig-journal-showcase')) {
  customElements.define('bitig-journal-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const tabs = [...this.querySelectorAll('[data-story-tab]')];
      if (!tabs.length) return;
      this.dataset.ready = 'true';
      this.querySelector('[data-story-tabs]').setAttribute('role', 'tablist');
      const activate = selected => tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('is-selected', active);
        this.querySelector(`#${tab.dataset.storyTab}`).hidden = !active;
      });
      tabs.forEach((tab, index) => {
        const panel = this.querySelector(`#${tab.dataset.storyTab}`);
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          activate(tab);
        });
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          const step = event.key === 'ArrowDown' ? 1 : event.key === 'ArrowUp' ? -1
            : event.key === 'ArrowRight' ? (rtl ? -1 : 1) : event.key === 'ArrowLeft' ? (rtl ? 1 : -1) : 0;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
            : step ? (index + step + tabs.length) % tabs.length : null;
          if (event.key === ' ') { event.preventDefault(); activate(tab); }
          if (next === null) return;
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus({preventScroll:true});
        });
      });
      activate(tabs[0]);
    }
  });
}
